import { AutogenModelOrderPlanningProfile, AutogenRowOrderPlanningProfile } from "./autogen/AutogenModelOrderPlanningProfile";

export class ModelOrderPlanningProfile extends AutogenModelOrderPlanningProfile<RowOrderPlanningProfile> {
	constructor() {
		super(RowOrderPlanningProfile);
	}
}

export class RowOrderPlanningProfile extends AutogenRowOrderPlanningProfile {
}
